import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { provideValueAccessor } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/required-indicator";
import * as i2 from "@angular/common";
/**
 * @deprecated since version 9.0
 */
export class TextAreaComponent {
    changeDetectorRef;
    id = null;
    label;
    maxlength = null;
    placeholder = null;
    value;
    cols = 3;
    rows = 4;
    inputBlur = new EventEmitter();
    inputFocus = new EventEmitter();
    inputChange = new EventEmitter();
    _disabled = null;
    _required = false;
    textareaElRef;
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
    }
    get required() {
        return this._required;
    }
    set required(val) {
        this._required = this.initAttrValue(val);
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(val) {
        this._disabled = this.initAttrValue(val);
    }
    initAttrValue(val) {
        if (val !== undefined && val !== false) {
            return true;
        }
        return val;
    }
    onInput(event, value) {
        this.inputChange.emit({ event, value });
        this.onChange(value);
    }
    onBlur(event, value) {
        this.inputBlur.emit({ event, value });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = (_) => { };
    onTouch = (event) => {
        this.inputFocus.emit({
            event,
            componentInstance: this,
        });
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetectorRef.markForCheck();
    }
    writeValue(val) {
        if (val !== this.value) {
            const normalizedValue = val == null ? '' : val;
            this.value = normalizedValue;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TextAreaComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TextAreaComponent, selector: "mhe-textarea", inputs: { id: "id", label: "label", maxlength: "maxlength", placeholder: "placeholder", value: "value", cols: "cols", rows: "rows", required: "required", disabled: "disabled" }, outputs: { inputBlur: "inputBlur", inputFocus: "inputFocus", inputChange: "inputChange" }, providers: [provideValueAccessor(TextAreaComponent)], viewQueries: [{ propertyName: "textareaElRef", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"ahe-ui form-group\">\n  <label *ngIf=\"label\" [attr.for]=\"id\"\n    >{{ label }}<mhe-required-indicator [required]=\"required\"></mhe-required-indicator\n  ></label>\n  <textarea\n    #input\n    class=\"form-control\"\n    [attr.cols]=\"cols\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.id]=\"id\"\n    [attr.maxlength]=\"maxlength\"\n    [attr.placeholder]=\"placeholder\"\n    [attr.rows]=\"rows\"\n    [value]=\"value\"\n    (focus)=\"onTouch($event)\"\n    (blur)=\"onBlur($event, input.value)\"\n    (input)=\"onInput($event, input.value)\"\n    [attr.required]=\"required ? '' : null\"\n    >{{ value }}</textarea\n  >\n</div>\n", styles: ["\n"], components: [{ type: i1.RequiredIndicatorComponent, selector: "mhe-required-indicator", inputs: ["required", "inverted"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TextAreaComponent, decorators: [{
            type: Component,
            args: [{ providers: [provideValueAccessor(TextAreaComponent)], styles: ["/*# sourceMappingURL=textarea.component.css.map */\n"], selector: 'mhe-textarea', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ahe-ui form-group\">\n  <label *ngIf=\"label\" [attr.for]=\"id\"\n    >{{ label }}<mhe-required-indicator [required]=\"required\"></mhe-required-indicator\n  ></label>\n  <textarea\n    #input\n    class=\"form-control\"\n    [attr.cols]=\"cols\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.id]=\"id\"\n    [attr.maxlength]=\"maxlength\"\n    [attr.placeholder]=\"placeholder\"\n    [attr.rows]=\"rows\"\n    [value]=\"value\"\n    (focus)=\"onTouch($event)\"\n    (blur)=\"onBlur($event, input.value)\"\n    (input)=\"onInput($event, input.value)\"\n    [attr.required]=\"required ? '' : null\"\n    >{{ value }}</textarea\n  >\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], cols: [{
                type: Input
            }], rows: [{
                type: Input
            }], inputBlur: [{
                type: Output
            }], inputFocus: [{
                type: Output
            }], inputChange: [{
                type: Output
            }], textareaElRef: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });
